import React from "react";
import ImageUploadAndFix from "./ImageUploadAndFix";

const ImageUploadTestPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">
      <h1 className="text-2xl font-bold mb-4">Image Upload Upright Test</h1>
      <p className="text-gray-700 mb-6 text-center max-w-md">
        Use this page to test uploading images at any angle (portrait,
        landscape, upside-down). The component should always render them
        vertically upright in the preview.
      </p>

      <div className="w-full max-w-md">
        <ImageUploadAndFix />
      </div>
    </div>
  );
};

export default ImageUploadTestPage;
